/**
 * Le thème de l'espace parent, d'après la règle commune (`isDarkFor`).
 */
import { isDarkFor } from "./appearanceTheme"
import type { ParentAppearancePreference } from "./parentAppearancePreference"

/** Les deux thèmes parent enregistrés dans `design-system/unistyles.ts`. */
export type ParentThemeName = "parent" | "parentDark"

export function parentThemeFor(
    systemScheme: "light" | "dark" | null | undefined,
    preference: ParentAppearancePreference
): ParentThemeName {
    return isDarkFor(systemScheme, preference) ? "parentDark" : "parent"
}
